<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    @hideModal="hideModal()"
  >
    <template #header>
      <span v-if="regenerate && idCollection.length === 1">{{ $t('views.agreements.list.options.generateInvoiceFromAgreementAgain') }}</span>
      <span v-else-if="regenerate && idCollection.length > 1">{{ $t('views.exsbinvoices.list.generateInvoiceFromAgreementAgain') }}</span>
      <span v-else-if="idCollection && idCollection.length > 0">{{ $t('views.agreements.list.options.generateInvoicesFromAgreementsSelected') }}</span>
      <span v-else>{{ $t('views.agreements.list.options.generateInvoicesFromAgreements') }}</span>
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col cols="12">
          <b-form-group>
            <label>{{$t('views.application.show.created')}}:</label>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              id="date"
              v-model="date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <button type="button" class="btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button
            type="button"
            class="btn btn-success float-right"
            @click="generateInvoices()"
          >
            {{$t('buttons.accept')}}
          </button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'GenerateInvoicesFromAgreementModal',
  components: {
    BaseModal
  },

  data () {
    return {
      date: this.$moment().format('YYYY-MM-DD')
    }
  },
  created () {
  },
  props: ['id', 'idCollection', 'regenerate'],
  computed: {
    ...mapGetters({
      isVisible: 'agreements/generateInvoicesFromAgreementModal/isVisible',
      response: 'agreements/generateInvoicesFromAgreementModal/response'
    })
  },
  watch: {
    response (val) {
      if (val.status === 207 || val.status === 200) {
        this.hideModal()
        this.$router.push({ path: '/admin/e_x_s_b_not_accepted_invoices/list?a=0' })
      }
    }
  },
  methods: {
    generateInvoices () {
      this.generateInvoicesFromAgreements({
        body: {
          'date': this.date,
          'selections': this.idCollection,
          'regenerate': this.regenerate
        }
      })
    },
    hideModal () {
      this.$emit('reset')
      this.toggleGenerateInvoicesFromAgreementsModal()
    },
    ...mapMutations({
      toggleGenerateInvoicesFromAgreementsModal: 'agreements/generateInvoicesFromAgreementModal/toggleModal'
    }),
    ...mapActions({
      generateInvoicesFromAgreements: 'agreements/generateInvoicesFromAgreementModal/generateInvoicesFromAgreements'
    })
  }
}
</script>
